'use strict';

// Gigya is rendered asynchronously after the page request completes.
// Keeping the global fullscreen spinner alive until onAfterScreenLoad avoids
// exposing an empty or partially rendered account/login area in the meantime.
function isPageHoldSpinnerAlreadyVisible() {
	var $body = $('body');
	var holdAttr = $body.attr('data-lvz-page-loader-hold') === 'true';
	var ariaBusy = $body.attr('aria-busy') === 'true';
	var hasInitialVeil = $body.find('[data-lvz-initial-page-loader="true"]').filter(':not(.d-none)').length > 0;
	var hasLivePageVeil = $body.find('.lvz-veil.lvz-veil--page').filter(':not(.d-none)').length > 0;

	return (holdAttr && ariaBusy) || hasInitialVeil || hasLivePageVeil;
}

function setGigyaPageLoading(isLoading) {
	if (!$.spinner) {
		return;
	}

	if (isLoading) {
		$.spinner().holdLifecycle();

		// When the page is rendered with an initial fullscreen loader, spinner.js
		// already bootstraps a body-level veil on DOM ready. Starting it again would
		// increment the ref counter to 2 and later a single stop() would not be enough
		// to remove the loader once Gigya is ready.
		if (!isPageHoldSpinnerAlreadyVisible()) {
			$.spinner().start();
		}

		return;
	}

	$.spinner().releaseLifecycle();
	$.spinner().forceStop();
}

module.exports = {
	setGigyaPageLoading: setGigyaPageLoading
};
